/**
 * config/mealsAdmin.js — where Fusion Eat's admin lives since it left this app
 * (16 Oct 2026): its own site, admin.fusion-eat.com (src/fusion-admin/, built
 * from this same project). Old /meals links and people whose only app is
 * "meals" are sent there.
 */
export const MEALS_ADMIN_URL = import.meta.env.VITE_MEALS_ADMIN_URL || "https://admin.fusion-eat.com";
